import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import 'amfe-flexible'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

axios.defaults.baseURL = 'https://eapi.equinoxlabs.ai'

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.$axios = axios
Vue.prototype.$get = (url, data = {}) => {
  const token = localStorage.getItem('BearerToken')
  const headers = token ? { authorization: token } : {}
  return axios.get(url, { params: data, headers }).then(res => res.data)
}
Vue.prototype.$post = (url, data = {}) => {
  const token = localStorage.getItem('BearerToken')
  const headers = token ? { authorization: token } : {}
  return axios.post(url, data, { headers }).then(res => {
    const payload = res && res.data ? res.data : undefined
    if (payload && payload.code === 1112) {
      store.state.relogin = true
      // return payload
    }
    return payload
  })
}

Vue.prototype.$getMsg = (code)=>{
  const lang = localStorage.getItem('lang') || 'en'
  const errorDist = JSON.parse(localStorage.getItem('errorDist') || '[]')
  const errorItem = errorDist.find(item => item.Tid === code)
  if (errorItem) {
    const messageKey = lang === 'zh' ? 'Mess_zh' : 'Mess_en'
    const errorMessage = errorItem[messageKey] || `Error: ${code}`
    return errorMessage
  }
  return `Unknown error code: ${code}`
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
